/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from "react";
import { Modal, Form, Input, Select, message, Button } from "antd";
import { useGlobalModalContext } from "../../context/global-modal-context";

export default function LogoutModal() {
  const { hideModal, store } = useGlobalModalContext();
  const { modalProps } = store || {};
  const { title, confirmBtn, action } = modalProps || {};
  const [form] = Form.useForm();
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const handleModalToggle = () => {
    hideModal();
  };

  return (
    <div>
      <Modal
        title={title || "Logout"}
        open={true}
        cancelButtonProps={{ hidden: true }}
        onCancel={handleModalToggle}
        okButtonProps={{ hidden: true }}
      >
        <div className="p-4">
          <h1>Are you sure </h1>
        </div>
      </Modal>
    </div>
  );
}
